<template>
  <div>
    <!--nav-bar></nav-bar-->
    <div class="login_tit">
       <img src="../../assets/image/xf_vue_index.jpg" hight="100px" width="100px" alt="center">
    </div>
    <section style="padding: 30px 30px; display: flex; flex-flow: column nowrap;">
      <div style="font-size: 20px; font-weight: bold;">密码登录</div>
      <div>
        <van-cell-group>
          <van-field
                  v-model="idcard"
                  clearable
                  placeholder="请输入标准的身份证号"
                  style="background-color: WhiteSmoke"
                  ref="idcard"
				  @blur="blur"
          >
          </van-field>
          <van-field
                  v-model="pwd"    
                  clearable
                  placeholder="请输入密码"
                  style="background-color: WhiteSmoke"
                  ref="pwd"
                  type="password"
          >
          </van-field>
        </van-cell-group>
        <span style="color: red" v-show="errMsg">{{ errMsg }}</span>
      </div>

      <div style="background-color: DarkGray">
        <van-button :type="type" block :disabled="loginDisabled" @click="login">登录</van-button>
      </div>
      <div>
        <a @click="toRegister">注册</a> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;<a @click="toRetrievePwd">找回密码</a>
      </div>
    </section>
  </div>
</template>

<script>
  import NavBar from "@/components/NavBar";
  import {isPhone} from "@/utils/commons";
  import {IsCard}  from "@/utils/commons";
  import { loginByPwd,queryStatus } from "@/api";

  export default {
    name: "LoginByPwd",
    components: {NavBar},
    mounted(){
      // 输入框聚焦
      if(!this.idcard){
        this.$refs.idcard.focus();
      }else {
        this.$refs.pwd.focus();
      }
	  this.idcard = this.$store.state.idcard;
	  //console.log(this.$store.state)
    },
	activated(){
	  this.$refs.idcard.focus();
	  // this.idcard = this.$store.state.idcard;
	  // console.log(this.idcard)
	},
    watch:{
      // 监听手机号和密码输入框，修改登录按钮状态和类型
      // pwd(newVal){
      //   //console.log(this.tel)
      //   if(IsCard(this.tel) && newVal.length > 0){
      //     this.loginDisabled = false;
      //     this.type = 'danger'
      //   } else {
      //     this.loginDisabled = 'disabled';
      //     this.type = 'default'
      //   }
      // },
      // tel(newVal, oldVal){
      //   //this.tel = this.tel.replace(/\s+/g, '').replace(/\D/g, '');
      //    if (newVal.length > 18) {
      //      this.tel = oldVal;
      //      return
      //    }
      //   if(IsCard(this.tel) && this.pwd.length > 0){
      //     this.loginDisabled = false;
      //     this.type = 'danger'
      //   } else {
      //     this.loginDisabled = 'disabled';
      //     this.type = 'default'
      //   }
      // }
    },
    data(){
      return {
        // 登录按钮类型
        type: 'danger',
        // 身份证号
        idcard: this.$store.state.idcard,
        // 密码
        pwd: '',
        // 错误提示信息
        errMsg: '',
        // 登录按钮是否禁用
        loginDisabled: false
      }
    },
    methods: {
      blur(){
        // 修改store中phone
        if(IsCard(this.idcard)){
          this.$store.commit('updateIdcard', this.idcard)
        }
      },
      // 登录
      login(){
        let that=this;
        let params = {
          idcard: this.idcard,
          password: this.pwd
        };
        loginByPwd(params).then(res => {
          if(res.code !== 200){
            that.errMsg = res.msg;
            // 密码输入错误时重新聚焦输入框
            that.$refs.pwd.focus();
          } else {
            let data=res.data;
            that.$store.commit('login', res.data);
            if(data.status==="0"){
				//先跳到确认页，然后再进注册页20220119需求
              that.$router.push('/confirm'); 
            }else{
              //that.$router.push('/registration');
              that.jumpPage(data);
            }
          }
        })
      },
      jumpPage(data){
        let that=this;
        let types,number;
		console.log(data);
        // if(data.train_stat!=="0" && data.last_condidate=="3"){
        //   types="employ";
        // }else if(data.j_last_condidate!=="0" && data.interview=="3"){
        //   types="last_condidate";
        // }else if(data.j_interview!=="0" && data.psychological_test=="3"){
        //   types="interview";
        // }else if(data.j_psychological_test!=="0" && data.physical_fitness=="3"){
        //   types="psychological_test";
        // }else if(data.j_physical_fitness!=="0" && data.physical_examination=="3"){
        //   types="physical_fitness";
        // }else if(data.j_physical_examination!=="0" && data.first_condidate=="1"){
        //   types="physical_examination";
        // }else{
        //   types="first_condidate";
        // }
		if(data.employ=="1" || data.employ=="2"){
		  types="employ"; //最终录用
		}else if(data.last_condidate=="1" || data.last_condidate=="2"){
		  types="last_condidate"; //政审
		}else if(data.psychological_test=="1" || data.psychological_test=="2"){
		  types="psychological_test"; //心测
		}else if(data.interview == "1" || data.interview=="2"){
		  types="interview"; //面试
		}else if(data.theory_test=="1" || data.theory_test=="2"){
		  types="theory_test"; //理论考试
		}else if(data.physical_fitness=="1" || data.physical_fitness=="2"){
		  types="physical_fitness"; //体能
		}else if(data.physical_examination=="1" || data.physical_examination=="2"){
		  types="physical_examination"; //体检
		}else if(data.first_condidate=="1" && data.physical_examination=="3"){
		  types="physical_examination_notice"; //体检通知
		}else{
		  types="first_condidate"; //初审
		}
        localStorage.setItem('Types', types);
        that.$router.push('/news');
      },
      //注册
      toRegister(){
          this.$router.push('/register');
          //this.errMsg = '报名已结束，感谢您的参与。';
         },
      // 去找回密码
      toRetrievePwd(){
        // if(!IsCard(this.tel)){
        //   this.errMsg = "身份证号填写错误";
        //   this.$refs.phone.focus()
        // }else{
        //   this.$router.push('/retrievePwd');
        //   this.errMsg = ''
        // }
		this.$router.push('/loginBycode');
		this.errMsg = ''
      }
    }
  }
</script>

<style scoped>
.login_tit {
  display: flex;
  justify-content: center;
  align-items: center;
}
.login_tit img{
  width : 100%;
}

  section div {
    margin-bottom: 10px;
  }
</style>
